module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar dados bancários'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do banco",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.nomeBanco),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "nomeBanco", $$v)
      },
      expression: "dadosBancarios.nomeBanco"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número do banco",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.numeroBanco),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "numeroBanco", $$v)
      },
      expression: "dadosBancarios.numeroBanco"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Agência",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "agencia", $$v)
      },
      expression: "dadosBancarios.agencia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Conta",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "conta", $$v)
      },
      expression: "dadosBancarios.conta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código de Operação",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.codigoOperacao),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "codigoOperacao", $$v)
      },
      expression: "dadosBancarios.codigoOperacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Tipo de conta:",
      "required": "",
      "rules": _vm.regrasBasicas,
      "row": ""
    },
    model: {
      value: (_vm.dadosBancarios.tipoConta),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "tipoConta", $$v)
      },
      expression: "dadosBancarios.tipoConta"
    }
  }, [_c('v-radio', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Conta Corrente",
      "value": "C"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Poupança",
      "value": "P"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "black--text text-justify text-h6"
  }, [_vm._v("\n\n                  Eu, " + _vm._s(_vm.bolsista.nomePessoa.toUpperCase()) + ", comprometo-me a cumprir as atividades relacionadas à bolsa vinculada a ação de extensão " + _vm._s(_vm.bolsista.nomeProjeto.toUpperCase()) + " pelo\n                  período de " + _vm._s(this.dates.format(_vm.bolsista.dataInicio)) + " a " + _vm._s(this.dates.format(_vm.bolsista.dataFim)) + ", apresentando os relatórios semestrais de atividade obrigatórias\n                  do bolsista e de acordo com as normas vigentes no edital.\n\n                  "), _c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "center": ""
    },
    model: {
      value: (_vm.concordo),
      callback: function($$v) {
        _vm.concordo = $$v
      },
      expression: "concordo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Concordo",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não concordo",
      "value": false
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.concordo
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc0cfb54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/dados-bancarios.vue
// module id = 396
// module chunks = 0